/** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
export const COLORS = {
  azure: '#0076D1',
  lightBlue: '#00a6ff',
  jade: '#2ddeab',
  lightGreen: '#DCFCE7',
  darkGreen: '#0e8273',
  darkGrey: '#6d7581',
  darkerGrey: '#3f4956',
  darkestGrey: '#374151',
  blueBlack: '#212934',
  blueGrey: '#e0ebf1',
  medDarkGrey: '#c8d0da',
  medGrey: '#8f98a5',
  grey: '#dfe3e8',
  lightestGrey: '#f9fafc',
  lighterGrey: '#f2f4f7',
  white: '#ffffff',
  yellow: '#feff80',
  lightYellow: '#FEF3C7',
  brownOrange: '#78350F',
  orange: '#ff6c45',
  orangeDark: '#ff3905',
  errorOrange: '#c94a1a',
  lightOrange: '#fff7f5',
  magenta: '#eb7dd8',
  magentaDark: '#d659c1',
  gold: '#ffda3f',
  goldDark: '#f7c400',
  cobalt: '#2678ff',
  cobaltDark: '#0351d2',
  skyBlue: '#69c2ff',
  skyBlueDark: '#0097ff',
  ceruleanBlue: '#0060AA',
  covidGreen: '#1ca383',
  violet: '#be64ec',
  violetDark: '#9e36d1',
  raven: '#6d7581',
  ravenDark: '#3f4956',
  sand: '#d8af69',
  sandDark: '#d09f00',
  pink: '#fef2ee',
  lightPink: '#f8e7f4',
  darkPink: '#6D0356',
};

/** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
export const textColors = {
  default: COLORS.darkerGrey,
  secondary: COLORS.medGrey,
  neutral: COLORS.darkGrey,
  summer: COLORS.azure,
  error: COLORS.errorOrange,
  light: COLORS.white,
  dark: COLORS.blueBlack,
};

/** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
export const MobileSize = '600px';
/** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
export const TabletSize = '768px';
/** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
export const SmallDesktopSize = '1024px';
/** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
export const DesktopHDSize = '1440px';

/** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
export const SidebarWidth = `224px`;
/** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
export const CollapseSidebarSize = SmallDesktopSize;

// guid layout
/** @deprecated `@summer/ui-components` is end-of-life; prefer `@summer/ui-mosaic`. */
export const SCROLL_OFFSET = 88;
